import { render } from "./ArchivedCollections.vue?vue&type=template&id=0421487d"
import script from "./ArchivedCollections.vue?vue&type=script&lang=js"
export * from "./ArchivedCollections.vue?vue&type=script&lang=js"
script.render = render

export default script